
const digest = '9d9eceda563627011728f23f987d05f67da9554ea3b77a19c5b3d2bbcb138750';
const classes = {"wrapper":"_wrapper_1uxir_1","title":"_title_1uxir_7","formWrapper":"_formWrapper_1uxir_11","button":"_button_1uxir_14"};
const css = `._wrapper_1uxir_1 {
  font-family: Poppins, sans-serif;
  background: #ffffff;
  padding: 24px;
  border-radius: 30px;
}
._wrapper_1uxir_1 ._title_1uxir_7 {
  font-size: 24px;
  font-weight: 600;
}
._wrapper_1uxir_1 ._formWrapper_1uxir_11 {
  margin-top: 20px;
}
._wrapper_1uxir_1 ._button_1uxir_14 {
  border-color: #d81616;
  background-color: #d81616;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 13px 16px;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  margin-top: 20px;
  border-radius: 25px;
}
._wrapper_1uxir_1 ._button_1uxir_14:hover, ._wrapper_1uxir_1 ._button_1uxir_14:active, ._wrapper_1uxir_1 ._button_1uxir_14:focus {
  border-color: #b00b0b !important;
  background-color: #b00b0b !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  